import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';

const AllCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const THEME_COLOR = '#065f46';

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES)
            .then(res => setCategories(res.data || []))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '120px' }}>
            <div className="container py-5">
                <div className="mb-5">
                    <Link to="/" className="text-decoration-none fw-bold mb-3 d-inline-block" style={{ color: THEME_COLOR }}>
                        <i className="ri-arrow-left-line"></i> Back to Home
                    </Link>
                    <h1 className="display-5 fw-bold" style={{ color: '#064e3b' }}>All Categories</h1>
                    <p className="text-muted">Browse services by category to find exactly what you need.</p>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border" style={{ color: THEME_COLOR }} role="status"></div>
                    </div>
                ) : (
                    <div className="row g-4">
                        {categories.map(cat => (
                            <div className="col-6 col-md-4 col-lg-2" key={cat.categoryId}>
                                <div 
                                    className="card border-0 shadow-sm h-100 text-center p-3" 
                                    style={{ borderRadius: '1.2rem', cursor: 'pointer', transition: 'all 0.3s' }}
                                    onClick={() => navigate(`/salons-by-category/${cat.categoryId}/${encodeURIComponent(cat.name)}`)}
                                    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <img src={cat.imageSrc} alt={cat.name} className="rounded-circle mx-auto mb-2" style={{ width: '60px', height: '60px', objectFit: 'cover' }} />
                                    <h6 className="fw-bold mb-0 small" style={{ color: '#064e3b' }}>{cat.name}</h6>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllCategories;